import React from "react";
import { DashboardMainHeader } from "../DataGuardCommonComponents";

function DetailPageHeader({selected, setSelected}) {
  return (
    <div>
      <DashboardMainHeader title="DataGuard Overview" loc="detailsPage" selected={selected} setSelected={setSelected} />
    </div>
  );
}

export default DetailPageHeader;
